<template>
	<div>
		<PageHeader
			:data="{
				name: department.first_name + ' ' + department.last_name,
				breadcrumbs: [
					{ name: 'Home', to: '/' },
					{ name: 'Departments', to: '/departments' },
				],
			}"
		/>
		<form @submit.prevent="updateDepartment">
			<div class="row">
				<div class="col-4">
					<div class="card mb-2">
						<div class="card-body">
							<div class="row border-bottom mb-2 pb-1">
								<div class="col-2">
									<h1 v-if="department.type === 'Police department'">🚓</h1>
									<h1 v-if="department.type === 'Fire department'">🚒</h1>
								</div>
								<div class="col-10">
									<h4 class="mb-0">
										{{ department.name }}
									</h4>
									<span>{{ department.type }} </span>
								</div>
							</div>
							<div class="row mb-0 pb-1 border-bottom pb-2 mb-2">
								<div class="col-2">
									<h1 v-if="department.type === 'Police department'" class="p-0 m-0" role="button">
										👮
									</h1>
									<h1 v-if="department.type === 'Fire department'" class="p-0 m-0" role="button">
										🧑‍🚒
									</h1>
								</div>
								<div class="col-10">
									<h4 class="mb-0 p-0">{{ department.first_name }} {{ department.last_name }}</h4>
									<a :href="'mailto:' + department.email">{{ department.email }}</a>
								</div>
							</div>
							<div class="row">
								<div class="col-12 d-flex justify-content-between mb-2">
									<span>Created</span>
									<span>{{ department.created_at | localDate }}</span>
								</div>
							</div>
						</div>
					</div>

					<div class="card mb-2" v-if="department.municipality">
						<div class="card-body">
							<div class="row border-bottom mb-2 pb-1">
								<div class="col-2">
									<h1>🏛️</h1>
								</div>
								<div class="col-10">
									<h4 class="mb-0">
										{{ department.municipality.full_name }}
										<a
											v-if="department.municipality.salesforce_account_id"
											target="_blank"
											:href="'https://hejdevdoo.lightning.force.com/lightning/r/Account/' + department.municipality.salesforce_account_id + '/view'"
											><img
												src="https://a.sfdcstatic.com/shared/images/c360-nav/salesforce-with-type-logo.svg"
												width="36"
												:title="'Salesforce ID' + department.municipality.salesforce_account_id"
											/>
										</a>
									</h4>
									<span>{{ department.municipality.county }}, {{ department.municipality.state }} </span>
								</div>
							</div>

							<p class="m-0 p-0"><b>Population</b> 🧑‍🤝‍🧑 {{ department.municipality.population }}</p>
							<p class="m-0 p-0">
								<b>FIPS</b>:
								<a target="_blank" :href="'https://google.com/search?q=FIPS+' + department.municipality.fips">
									{{ department.municipality.fips }}
								</a>
							</p>
							<p class="m-0 p-0"><b>FIPS full</b>: {{ department.municipality.fips_full }}</p>

							<p class="m-0 p-0" v-if="department.municipality.website">
								<b>Website</b>:
								<a v-if="department.municipality.website.includes('http')" :href="department.municipality.website" target="_blank"
									>{{ department.municipality.website }} 🔗</a
								>
								<a v-else :href="'http://' + department.municipality.website" target="_blank">{{ 'http://' + department.municipality.website }} 🔗</a>
							</p>
						</div>
					</div>
				</div>
				<div class="col-8">
					<div class="card mb-2">
						<div class="card-body">
							<div class="row">
								<div class="col-12">
									<div class="d-flex justify-content-start align-items-center">
										<h5 class="p-0 m-0 me-1">Department info</h5>
										<button
											data-bs-toggle="offcanvas"
											data-bs-target="#offcanvasActivities"
											aria-controls="offcanvasActivities"
											class="btn btn-link btn-sm p-0 m-0 mt-1"
											title="Department history of changes"
											type="button"
										>
											<font-awesome-icon :icon="['fas', 'history']" />
										</button>
									</div>

									<div class="form-group mb-2">
										<label for="">Department Name</label>
										<input type="text" class="form-control" v-model="department.name" />
									</div>
									<div class="form-group mb-2">
										<label for="">Type</label>
										<select class="form-select" v-model="department.type">
											<option value="Police department">Police department</option>
											<option value="Fire department">Fire department</option>
										</select>
									</div>
									<!-- If type is municipality show municipality search -->
									<div class="mb-2">
										<MunicipalitySearch
											v-if="department.municipality"
											excludeClients="false"
											:selected="department.municipality"
											v-on:setMunicipality="setMunicipality"
										/>
									</div>
									<div class="form-group mb-2">
										<label for="">Website</label>
										<input type="text" class="form-control" v-model="department.website" />
									</div>
									<div class="form-group mb-2">
										<label for="">First Name</label>
										<input type="text" class="form-control" v-model="department.first_name" />
									</div>
									<div class="form-group mb-2">
										<label for="">Last Name</label>
										<input type="text" class="form-control" v-model="department.last_name" />
									</div>
									<div class="form-group mb-2">
										<label for="">Email</label>
										<input type="text" class="form-control" v-model="department.email" />
									</div>
									<div class="form-group mb-2">
										<label for="">Phone</label>
										<input type="text" class="form-control" v-model="department.phone" />
									</div>
								</div>
							</div>
						</div>
					</div>
					<button v-if="authUser.permissions.includes('CONTACT_UPDATE')" type="submit" class="btn btn-primary float-end">
						Update
					</button>
				</div>
			</div>
		</form>

		<Activities :key="activityKey" :subjectType="'App\\Models\\Department'" :subjectId="$route.params.id" />
	</div>
</template>

<script>
import PageHeader from '@/components/layout/PageHeader'
import { mapState } from 'vuex'
import restApi from '../../api/index.js'
import { handleErrors } from '../../actions/helpers'
import Activities from '@/components/Activities'
import MunicipalitySearch from '@/components/municipality/MunicipalitySearch'

export default {
	name: 'DepartmentEdit',
	components: { PageHeader, Activities, MunicipalitySearch },
	data() {
		return {
			loading: false,
			department: {
				name: 'Department',
				municipality_id: '',
			},
			activityKey: 0,
			unsubscribed: 0,
		}
	},
	computed: {
		...mapState(['authUser', 'storageUrl']),
	},
	created() {
		this.loadingClient = true
	},

	methods: {
		// Get Client
		getDepartment() {
			restApi
				.get(`/departments/${this.$route.params.id}`)
				.then(({ data }) => {
					this.department = data
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Update department
		updateDepartment() {
			restApi
				.put(`/departments/${this.$route.params.id}`, this.department)
				.then(({ data }) => {
					this.department = data
					this.activityKey++
					this.$swal.fire({
						icon: 'success',
						title: 'Department successfully updated!',
						timer: 3000,
					})
					this.getDepartment()
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		setMunicipality(municipality) {
			if (municipality !== null) {
				this.department.municipality_id = municipality.id
			} else {
				this.department.municipality_id = ''
			}
		},
	},
	mounted: function() {
		this.getDepartment()
	},
	watch: {},
	filters: {
		localDate: function(value) {
			if (!value) return ''
			value = new Date(value)
			return value.toLocaleDateString()
		},
		localDateTime: function(value) {
			if (!value) return ''
			value = new Date(value)
			return value.toLocaleString()
		},
	},
}
</script>
